import React from 'react';
export function LockIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 10V7a5 5 0 00-5-5 5.006 5.006 0 00-5 5v3a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3v-6a3 3 0 00-3-3zM9 7a3 3 0 013-3 3 3 0 013 3v3H9V7zm9 12a1 1 0 01-1 1H7a1 1 0 01-1-1v-6a1 1 0 011-1h10a1 1 0 011 1v6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13a1.994 1.994 0 00-1 3.722V18a1 1 0 102 0v-1.282A1.994 1.994 0 0012 13z"
  }));
}